import api from '../../ApiConfig';
import { Apis } from '../../config';
var token = localStorage.getItem('userToken');
const getAllEmailTemplate = async () => {
  try {
    let result = await api.get(Apis.GetAllEmailTemplate, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};

const createEmailTemplate = async (data) => {
  try {
    let result = await api.post(Apis.CreateEmailTemplate, data, {
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const updateEmailTemplate = async (id, data) => {
  try {
    let result = await api.put(Apis.UpdateEmailTemplate+id, data,{
        headers: {
          'x-access-token': token
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const deleteEmailTemplate = async (id) => {
  try {
    let result = await api.delete(Apis.DeleteEmailTemplate+id, {
        headers: {
          'x-access-token': token,
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};
const getSingleEmailTemplate = async (id) => {
  try {
    let result = await api.get(Apis.GetSingleEmailTemplate+id, {
        headers: {
          'x-access-token': token,
        }
      });
    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
};


const exportedObject = {
 getAllEmailTemplate,
 createEmailTemplate,
 updateEmailTemplate,
 getSingleEmailTemplate,
 deleteEmailTemplate
};
export default exportedObject;